import {
  getAddress,
  addAddress,
  updateAddress,
  getProvince,
  getCity,
  getArea,
  getDistrict,
  getPostalCode,
  getTransaction,
} from '~/api/general-trade';

export const state = () => ({
  address: {},
  province: [],
  city: [],
  area: [],
  district: [],
  postalCode: [],
  transaction: {},
});

export const getters = {
  getAddress: state => state.address || {},
  getProvince: state => state.province || [],
  getCity: state => state.city || [],
  getArea: state => state.area || [],
  getDistrict: state => state.district || [],
  getPostalCode: state => state.postalCode || [],
  getTransaction: state => state.transaction || {},
};

export const mutations = {
  setAddress(state, data) {
    state.address = data;
  },
  setProvince(state, data) {
    state.province = data;
  },
  setCity(state, data) {
    state.city = data;
  },
  setArea(state, data) {
    state.area = data;
  },
  setDistrict(state, data) {
    state.district = data;
  },
  setPostalCode(state, data) {
    state.postalCode = data;
  },
  setTransaction(state, data) {
    state.transaction = data;
  },
};

export const actions = {
  async getAddress({ commit }) {
    try {
      const response = await getAddress(this.$axios);
      if (response.meta.http_status === 200) commit('setAddress', response.data);
      return response;
    } catch (error) {
      // handle error
    }
  },
  async getProvince({ commit }) {
    try {
      const response = await getProvince(this.$axios);
      if (response.meta.http_status === 200) commit('setProvince', response.data);
      return response;
    } catch (error) {
      // handle error
    }
  },
  async getCity({ commit }, { province }) {
    try {
      const response = await getCity(this.$axios, province);
      if (response.meta.http_status === 200) commit('setCity', response.data);
      return response;
    } catch (error) {
      // handle error
    }
  },
  async getArea({ commit }, { province, city }) {
    try {
      const response = await getArea(this.$axios, province, city);
      if (response.meta.http_status === 200) commit('setArea', response.data);
      return response;
    } catch (error) {
      // handle error
    }
  },
  async getDistrict({ commit }, { province, city, area }) {
    try {
      const response = await getDistrict(this.$axios, province, city, area);
      if (response.meta.http_status === 200) commit('setDistrict', response.data);
      return response;
    } catch (error) {
      // handle error
    }
  },
  async getPostalCode({ commit }, { province, city, area }) {
    try {
      const response = await getPostalCode(this.$axios, province, city, area);
      if (response.meta.http_status === 200) commit('setPostalCode', response.data);
      return response;
    } catch (error) {
      // handle error
    }
  },
  async submitAddress(store, { payload }) {
    try {
      const response = payload.id ? await updateAddress(this.$axios, payload) : await addAddress(this.$axios, payload);
      return response;
    } catch (error) {
      // handle error
    }
  },
  async getTransaction({ commit }, id) {
    try {
      const response = await getTransaction(this.$axios, id);
      if (response.meta.http_status === 200) commit('setTransaction', response.data);
      return response;
    } catch (error) {
      // handle error
    }
  },
};
